/* eslint-disable class-methods-use-this */
import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import { LoginUserInfo, UserInfo } from 'SharedDir/declarations/access';
import { NAccount } from 'SharedDir/declarations/account';
import { ACCOUNT } from 'SharedDir/backend/endpoints/account';
import { OrganizationFull } from 'SharedDir/declarations/organization';
import { Paginated, PaginationParams } from 'SharedDir/declarations/pagination';

export default class AccountApiClass {
  protected readonly url: string;

  constructor() {
    this.url = `${SERVER_API}/account/user-info`;
  }

  private getSingleEndpoint(): AxiosRequestConfig {
    return { url: this.url, method: 'get' };
  }

  private getUpdateEndpoint(): AxiosRequestConfig {
    return { url: this.url, method: 'post' };
  }

  public async get() {
    const endpoint = this.getSingleEndpoint();
    const { data } = (await http(endpoint)) as AxiosResponse<UserInfo>;
    return data;
  }

  public async update(data: NAccount.UserAccountUpdatable) {
    const endpoint = this.getUpdateEndpoint();
    const { data: saved } = (await http({
      ...endpoint,
      data,
    })) as AxiosResponse<UserInfo>;
    return saved;
  }

  public async changePassword(data: NAccount.SelfChangePassword): Promise<LoginUserInfo> {
    const { data: loginResponse } = (await http({
      ...ACCOUNT.CHANGE_PASSWORD,
      data,
    })) as AxiosResponse<LoginUserInfo>;
    return loginResponse;
  }

  public async getMyOrganizations() {
    const { data } = (await http({
      ...ACCOUNT.MY_ORGANIZATIONS,
    })) as AxiosResponse<Paginated<OrganizationFull>>;
    return data;
  }

  public async getMyProfiles() {
    const { data } = (await http({
      ...ACCOUNT.MY_PROFILES,
    })) as AxiosResponse<any>;
    return data;
  }

  public async getMyHousehold() {
    const { data } = (await http({
      ...ACCOUNT.MY_HOUSEHOLD,
    })) as AxiosResponse<NAccount.MyHouseHold>;
    return data;
  }
}
